import { Map } from "immutable"

import {
    USER_LIST_REQUEST as LIST_REQUEST,
    USER_LIST_RESPONSE as LIST_RESPONSE,
    USER_LIST_CACHED_RESPONSE as LIST_CACHED_RESPONSE,
    USER_LIST_ERROR_RESPONSE as LIST_ERROR_RESPONSE
} from "../../actions/action-types"
import buildPagingReducer from "./build-paging-reducer"

export const defaultSearchCriteria = Map({
    name: ""
})

export default buildPagingReducer(
    {
        LIST_REQUEST,
        LIST_RESPONSE,
        LIST_CACHED_RESPONSE,
        LIST_ERROR_RESPONSE
    },
    defaultSearchCriteria
)
